import * as types from 'model/actionTypes'

export function receiveItems (items: {}) {
  return {
    type: types.RECEIVE_ITEMS,
    items
  }
}
